import React from 'react';
import CategoryItems from '../CategoryItems';
import PostGallery from '../PostGallery';
import PostDistance from '../PostDistance';
import PostDifficulty from '../PostDifficulty';
import ArrowRight from '../../assets/images/icons/ArrowRight.svgr'; 

function post(props) {
  const {
    post,
    postType,
    displayAuthor,
    displayExcerpt,

    displayCategories,

    replaceSelected, 
    theExcerpt
  } = props;

  let categories;
  let categoryItems;
  let excerpt;
  let postGallery;
  let subtitle;
  let postDistanceTag
  let difficulty
  let postDifficultyTag
 
  if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:term')) {
    categories = post._embedded['wp:term'][0];
    difficulty = post._embedded['wp:term'][2];
  }

  if (categories && displayCategories) {
      categoryItems = <CategoryItems
      items = {categories}
    ></CategoryItems>
  }

  if (post.excerpt && displayExcerpt) {
    excerpt = <div className="eight29-post-excerpt" dangerouslySetInnerHTML={{__html: post.excerpt.rendered}}>
    </div>
  }

  if (post.acf_hike_gallery && post.acf_hike_gallery.length > 0) {
    postGallery = <div className="cpt-post-gallery">
      <div className="cpt-post-gallery-wrapper">
        <PostGallery
          post = {post}
          gallery = {post.acf_hike_gallery}
          imageSize = 'hiking-gallery'
        ></PostGallery>
      </div>
    </div>
  }

  if (post.acf_hike_subtitle) {
    subtitle = <span 
      className="eight29-post-subtitle" 
      dangerouslySetInnerHTML={{__html: post.acf_hike_subtitle}}/>
  }

  if (post.acf_hike_distance) {
    postDistanceTag = <PostDistance
    distance = {post.acf_hike_distance}
  ></PostDistance>
  }

  if (difficulty && difficulty.length > 0) {
    postDifficultyTag = <PostDifficulty
    term = {difficulty}
    icons = {post.acf_hike_difficulty}
  ></PostDifficulty>
  }

  return (
    <article id={`${postType}-${post.id}`} className="eight29-post eight29-post-card cpt-post hike-post">
      <div className="cpt-post-wrapper">
        <div className="cpt-post-left">
          {postGallery}
        </div>
        <div className="cpt-post-right">
          <div className="eight29-post-body">
            <div className="cpt-post-right-header">
              <div className="cpt-post-right-header-category">
              {categoryItems}
              </div>
            </div>
            <div className="eight29-post-detail">
              <div className="cpt-post-detail">
                <a className="cpt-post-link" href={post.link}>
                    <h3 className="eight29-post-title" dangerouslySetInnerHTML={{__html: post.title.rendered }}/>
                    {subtitle}
                </a>
                <div className="cpt-post-info">
                  {postDistanceTag}
                  {postDifficultyTag}
                </div>
                {excerpt}
              </div>
              <div className="cpt-post-buttons">
                <a href={post.link} className="c-btn c-btn-tertiary">
                  Learn more
                  <span className="c-btn-icon">
                    <ArrowRight></ArrowRight>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default post;